import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import enGB from 'antd/locale/en_GB';
import { ConfigProvider } from 'antd';
import './index.css'
import { Provider } from 'react-redux';
import store from './store';
import routes from './routes';
import { initializeAnalytics } from './analytics';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const theme = {
  "token": {
    "borderRadius": 30,
    "colorPrimary": "#1677FF",
    "colorInfo": "#1677FF",
    "wireframe": false,
    "colorBgContainer": "rgba(241, 244, 255, 1)",
    "colorBgLayout": "#f5f5f5",
    "fontFamily": "Poppins"
  },
  "components": {
    "Typography": {
      "titleMarginBottom": 0,
      "titleMarginTop": 0,
    }
  }
}

const router = createBrowserRouter(routes)

initializeAnalytics();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ConfigProvider
      theme={theme}
      locale={enGB}
    >
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ConfigProvider>
  </StrictMode>,
)

